export interface Tour {
  id: string;
  slug?: string;
  title: string;
  description: string;
  city: string;
  country: string;
  province: string;
  imageUrl: string;
  price: number;
  duration: number;
  distance: number;
  stops: number;
  guideId: string;
  guideName: string;
  rating: number;
  reviewCount: number;
  languages: string[];
  createdAt: Date;
  status: 'draft' | 'pending' | 'approved' | 'rejected';
  templateType?: string;
  tags: string[];
  latitude?: number;
  longitude?: number;
}

export interface TourStop {
  id: string;
  tourId: string;
  title: string;
  description: string;
  audioUrl: string;
  imageUrl: string;
  latitude: number;
  longitude: number;
  order: number;
  duration: number;
  imageGallery: string[];
  videoUrl?: string;
  video360Url?: string;
  backgroundMusicUrl?: string;
  arModelUrl?: string;
  mediaItems: StopMedia[];
  extraInfo?: Record<string, string>;
}

export interface StopMedia {
  url: string;
  type: 'image' | 'video360' | 'model3d';
  thumbnail?: string;
  caption?: string;
}

export interface User {
  id: string;
  email: string;
  displayName: string;
  photoUrl?: string;
  role: 'traveler' | 'guide' | 'admin';
  city?: string;
  country?: string;
  bio?: string;
  createdAt: Date;
  phoneNumber?: string;
  languages?: string[];
}

export const tourFromFirestore = (doc: any): Tour => {
  const data = doc.data();
  return {
    id: doc.id,
    slug: data.slug || undefined,
    title: data.title || '',
    description: data.description || '',
    city: data.city || '',
    country: data.country || '',
    province: data.province || '',
    imageUrl: data.imageUrl || '',
    price: data.price || 0,
    duration: data.duration || 0,
    distance: data.distance || 0,
    stops: data.stops || 0,
    guideId: data.guideId || '',
    guideName: data.guideName || '',
    rating: data.rating || 0,
    reviewCount: data.reviewCount || 0,
    languages: data.languages || [],
    createdAt: data.createdAt?.toDate() || new Date(),
    status: data.status || 'pending',
    templateType: data.templateType,
    tags: data.tags || [],
    latitude: data.latitude,
    longitude: data.longitude,
  };
};

export const stopFromFirestore = (doc: any): TourStop => {
  const data = doc.data();
  return {
    id: doc.id,
    tourId: data.tourId || '',
    title: data.title || '',
    description: data.description || '',
    audioUrl: data.audioUrl || '',
    imageUrl: data.imageUrl || '',
    latitude: data.latitude || 0,
    longitude: data.longitude || 0,
    order: data.order || 0,
    duration: data.duration || 0,
    imageGallery: data.imageGallery || [],
    videoUrl: data.videoUrl,
    video360Url: data.video360Url,
    backgroundMusicUrl: data.backgroundMusicUrl,
    arModelUrl: data.arModelUrl,
    mediaItems: data.mediaItems || [],
    extraInfo: data.extraInfo,
  };
};
